import React, { Component } from 'react'
//import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import {addSTAgentKitchensReady} from '../redux/stores'
import apiService from '../services/apiservices'
import { headerDataUpdate,subHeaderDataUpdate, buildNumberUpdate } from '../../../redux/user'
import * as Constants from '../../../common/constants'
//import  {ValidateEmail ,ValidatePhone,isLatitude,isLongitude} from '../../../common/ValidationFunctions/CommonValidation'

//import * as Helpers from '../../../common/helpers'

class AddSTAgentKitchens extends Component {

  constructor() {
    super()
    this.state = {

        bodyHeight: "0px",
        employeeName: "",
        employeeCode: "",

        kitchensList:[],
        selectedKitchens:[],

        subTitle: Constants.ADD_ST_AGENT_KITCHENS

    }

    this.isComponentStillMounted = true


}

componentWillMount() {
    this.isComponentStillMounted = true
    this.props.dispatch(addSTAgentKitchensReady(false))

    if (this.props.stores && this.props.stores.stAgentSelectedRow && this.props.stores.stAgentSelectedRow !== null) {
        this.props.dispatch(headerDataUpdate(Constants.ADD_ST_AGENT_KITCHENS))
        this.setState({
            subTitle: "Add Kitchens",
            employeeName: this.props.stores.stAgentSelectedRow.name,
            employeeCode: this.props.stores.stAgentSelectedRow.code
        })
    } else {
       this.props.history.goBack()
    }
    this.props.dispatch(subHeaderDataUpdate())

    window.addEventListener("resize", this.updateDimensions)
    this.updateDimensions()


    this.getAgentNonAssignedKitchensComboList()


    // if (this.props.stores && this.props.stores.stAgentSelectedRow && this.props.stores.stAgentSelectedRow !== null) {
    //     this.getSTagentKitchensById(this.props.stores.stAgentSelectedRow)
    // }else{

    // this.props.dispatch(addSTAgentKitchensReady(true))
    // }
}

componentDidMount() {

}

updateDimensions = () => {
    if (window.innerWidth <= 767) {
        this.setState({
            bodyHeight: (window.innerHeight - 130) + "px",
        })
    } else {
        this.setState({
            bodyHeight: (window.innerHeight - 100) + "px",
        })
    }
}

validateBuildNumber = (data) => {
    if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
        if (this.props.user.build_number === data.app_build_no) {
            //do smthng here
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    } else {
        this.props.dispatch(buildNumberUpdate(data.app_build_no))
        window.location.reload()
    }
}

componentWillUnmount() {
    this.isComponentStillMounted = false
    window.removeEventListener("resize", this.updateDimensions)
}


mandateValidation = (inputName, type) => {
    let inputComponent = inputName + "Component"
    let inputErrorText = inputName + "ErrorText"
    let inputErrorData = inputName + "ErrorData"
    let inputSection = inputName + "Section"
    let errorMsg = Constants.NON_VALID_MSG_INPUT
    if (Constants.FORM_SELECT === type) {
        errorMsg = Constants.NON_VALID_MSG_SELECT
        console.log("input name :::", inputName)
        console.log("input data :::", this.state[inputName])
    }
    if (this.state[inputName] === null || this.state[inputName] === undefined || this.state[inputName] === "") {
        this[inputComponent].focus()
        this.setState({
            [inputErrorText]: true,
            [inputErrorData]: errorMsg
        })
        this[inputSection].className = this[inputSection].className.replace(" has-error", "")
        this[inputSection].className += " has-error"
        return {
            status: false,
            value: ''
        }
    }
    return {
        status: true
    }
}

onSaveClick = () => {

    this.props.dispatch(addSTAgentKitchensReady(false))
    let data = {}

    data.employee_id=this.props.stores.stAgentSelectedRow.id;
    data.assigned_type="KITCHEN"

    data.assigned_details = this.state.selectedKitchens

    let apiPayloadData=data

     apiService.addSTAgentKichen(apiPayloadData)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(addSTAgentKitchensReady(true))
                        this.props.history.push("/dashboard/storestickets/agents/list")
                    } else {

                        this.props.dispatch(addSTAgentKitchensReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(addSTAgentKitchensReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })

}

integerValidation = (value) => {
    if (/\D/.test(value)) {
        return true
    } else {
        return false
    }
}

onCancelClick = () => {
    this.props.history.goBack()
}



getAgentNonAssignedKitchensComboList = () => {
    apiService.getAgentNonAssignedKitchensComboList()
        .then(responseData => {
            if (responseData) {

                if (responseData && responseData.data) {
                    let data = Object.entries(responseData.data);

                    data.sort(function(a, b) { return (a[1] > b[1] ? 1 : (a[1] === b[1] ? 0 : -1)) })

                    this.setState({
                        kitchensList: data
                    })

                    this.renderSelectOption(this.state.kitchensList)
                    this.props.dispatch(addSTAgentKitchensReady(true))        

                }

            }


        })
        .catch(err => {
            console.error("Error data: ", err)
            this.props.dispatch(addSTAgentKitchensReady(true))
        })
}




    renderSelectOption = (data) => {

    let kitchensList = data;
    let temp = '<select id="kitchenId" class="form-control">';
    for (let i = 0; i < kitchensList.length; i++) {
        temp += '<option value="' + kitchensList[i][0] + '">' + kitchensList[i][1] + '</option>';
    }
    temp += '</select>';
    let selectedElement = document.getElementById("selectIdRender");
    selectedElement.innerHTML = "";
    selectedElement.innerHTML = temp;


    //selectIdRender
}
   


addKitchenBtn = () => {

    let selectedValueId = document.getElementById("kitchenId").value;
    let selectedValueText = document.getElementById("kitchenId").options[document.getElementById("kitchenId").selectedIndex].text;
    let selectedKitchens = this.state.selectedKitchens;
    

    //let deletedKitchens = this.state.deletedKitchens;


         selectedKitchens.push({
            "assigned_id": selectedValueId,
            "kitchen_name": selectedValueText
        });
    

    this.setState({
        selectedKitchens: selectedKitchens
    });


    let kitchensList = this.state.kitchensList

    //let index = rolesList.indexOf(selectedValue);
    let index_i;
    kitchensList.map(function(item, index) {
        if (parseInt(item[0],10) === parseInt(selectedValueId,10)) {
            index_i = index
        }
        return true
    })

    if (index_i > -1) {
        kitchensList.splice(index_i, 1); // 2nd parameter means remove one item only
    }

    this.setState({
        kitchensList: kitchensList
    });

    this.renderSelectOption(this.state.kitchensList)
}




    render() {
        return (
            <div className="line-item-edit">

                <div className="col-md-12" style={{ "paddingBottom" : "1%"}}>
                    <a href="" 
                        onClick={(e) => {e.preventDefault() 
                                    this.props.history.goBack()}}> 
                            <i class="fa fa-arrow-left" aria-hidden="true"></i> Go Back
                    </a>
                </div>


                <Dialog ref={el => this.dialog = el} />
                <section className="content">
                    <div className="row">
                        <div className="col-md-12 col-sm-12 col-xs-12" style={{ height: this.state.bodyHeight }}>
                            <div className="box box-info" style={{ borderTop: "0px" }}>
                                <div className="box-header with-border">
                                    <h3 className="box-title" style={{ fontWeight: 600 }}>{this.state.subTitle}</h3>
                                </div>
                                <div className="form-horizontal">
                                    <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>
                                        
                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                           <div className="col-md-6 col-sm-12 col-xs-12">
                                              <div className="form-group">
                                                 <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Employee Id :</label>
                                                 <div className="col-sm-9">
                                                    <p>{this.state.employeeCode}</p>                                       
                                                 </div>
                                              </div>
                                            </div> 
                                           </div> 

                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                           <div className="col-md-6 col-sm-12 col-xs-12">
                                              <div className="form-group">
                                                 <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Employee Name :</label>
                                                 <div className="col-sm-9"><p>{this.state.employeeName}</p>                                       
                                                 </div>
                                              </div>
                                           </div> 

                                           </div> 

                                              <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">

                                                <div className="form-group">
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Select Kitchens*</label>
                                                    <div className="col-sm-9" id="selectIdRender">
                                                        <select id="kitchenId" className="form-control">
                                                          
                                                        </select>
                                                    </div>
                                                </div>

                                            
                                            </div>

                                             <div className="col-md-6 col-sm-12 col-xs-12">

                                            


                                             <div className="col-md-6">
                                                <div className="add-btn-box">
                                                     <button
                                                        className="btn btn-info"
                                                        onClick={(e) => {
                                                            e.preventDefault()
                                                            this.addKitchenBtn()
                                                        }}>
                                                        Add
                                                    </button>
                                                </div>
                                                </div>

                                                </div>

                                                </div>                                    
                                        

                                            
                                                </div>
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                            </div>
                                        </div>



                                          {(() => {

                                       if(this.state.selectedKitchens.length>0){
                                                                        return (
                                        <div className="col-md-12">
                                        <div className="col-md-6">
                                         <div className="form-horizontal">
                                    <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>
                                    <h4>Selected Kitchens</h4>


                                        <table className="table table-bordered" style={{textAlign:"left"}}>
                                    
                                                        <thead>
                                                            <tr><th>Kitchen Name</th></tr>
                                                        </thead>
                                                        <tbody>
                                                         {this.state.selectedKitchens.map((item, index) => (

                                                        <tr><td>{this.state.selectedKitchens[index].kitchen_name}</td>
                                                        
                                        

                                                        </tr>

                                                        ))}
                                                        </tbody>

                                            </table>
                                            </div>
                                            </div>
                                            </div>
                                            </div>

                                            )
                                        }

                                         })()}


                                    </div>

                                    <div className="box-footer">
                                        <button
                                            className="btn btn-default"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.onCancelClick()
                                            }}>
                                            Cancel
                                        </button>
                                        <button
                                            className="btn btn-info pull-right"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.onSaveClick()
                                            }}>
                                            Save Changes
                                        </button>
                                    </div>
                                </div>
                    </div>
                </section>
            </div>
        )
    }

    keyedInputChange = (keyedName) => {
        console.log(keyedName)
        let keyedComponent =keyedName+"Component"
        let keyedErrorText =keyedName+"ErrorText"
        let keyedErrorData =keyedName+"ErrorData"
        let keyedSection =keyedName+"Section"
        let name=this[keyedComponent].value.trim()
        this.setState({[keyedName]:name})
        if(!name){
            this.setState({[keyedName] : null})
            return
        }
        this.setState({ [keyedErrorText]: false, [keyedErrorData]: '' })
        this[keyedSection].className = this[keyedSection].className.replace(" has-error", "")
    }

}
function mapStateToProps(state) {
    return {
        stores: state.stores,
        user: state.user,
    }
}

export default connect(mapStateToProps)(withRouter(AddSTAgentKitchens))


// WEBPACK FOOTER //
// ./src/modules/Stores/Components/AddSTAgentKitchens.js